import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Nav } from "./shared/nav/nav";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule, Nav],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('libraries');
      private translate = inject(TranslateService);

    constructor() {
        this.translate.addLangs(['ar', 'en']);
        this.translate.setFallbackLang('ar');
        const lang = localStorage.getItem('lang') === 'en' ? 'en' : 'ar';
        this.translate.use(lang);
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    }
}
